import * as PIXI from "pixi.js";

export default class UIBaseContainer extends PIXI.Container {

  constructor(name = 'UIBaseContainer') {
    super()
    this.name = name
  }

  init() {
  }


}